import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TileButtonComponent } from './component/tile-button.component';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  declarations: [
    TileButtonComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  exports: [
    TileButtonComponent
  ]
})
export class TileButtonModule {

 }
